// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableContainer_root__A_-6E"};